import FlashLib from 'flashlib_onlyplay';
import GlobalDispatcher from 'Engine/events/GlobalDispatcher';
import EntryPoint from 'Engine/EntryPoint';
import { startScreenFontStyle } from '../../fontStyles';
import eEventTypes from '../../enums/eEventTypes';
import MoneyFormat from 'Engine/base/moneyFormat/MoneyFormat';
import LocalizeTextField from 'Engine/base/localization/LocalizeTextField';

export default class PaytableContent extends FlashLib.MovieClip{
  constructor(data, displayData) {
    super(data, displayData);

    this.currentFrame = 1;
    this.addListeners();
  }

  addListeners() {
    GlobalDispatcher.add(eEventTypes.EET_PAYTABLE__CHANGE_PAGE, this.changeFrame, this);
  }

  setMultipliersStyle() {
    switch (this.currentFrame) {
      case 1:
        const coefStyle = EntryPoint.GameModel.currencyInfo.decimals <= 3
          ? startScreenFontStyle
          : { ...startScreenFontStyle, fontSize: 38, lineHeight: 62 };

        for (let i = 1; i <= 8; i++) {
          const coefs = this.children[0].getChildByName(`paytable_p1_coefs${i}`)
          if (coefs) {
            coefs.style = { ...coefs.style, ...coefStyle }
          }
        }
        const wildFieldCoef = this.children[0].getChildByName('paytable_wild_coef');
        const wildFieldPlusChiliMaxCoef = this.children[0].getChildByName('paytable_chili_coef', true);
        wildFieldCoef.style = { ...wildFieldCoef.style, ...startScreenFontStyle}
        wildFieldPlusChiliMaxCoef.style = { ...wildFieldPlusChiliMaxCoef.style, ...startScreenFontStyle}
        break;
    }
  }

  setMultipliers() {
    switch (this.currentFrame) {
      case 1:
        for (let i = 1; i < Object.keys(EntryPoint.GameModel.paytableInfo).length; i++) {
          let element = this.children[0].getChildByName(`paytable_p1_coefs${i}`);
          if (element) {
            let coeffs = EntryPoint.GameModel.paytableCurrentInfo[i].slice(2).map((coeff, index) => `${index + 3} - ×${coeff}`);
            coeffs.reverse();
            element.text = coeffs.join('\n\n');
            element.correctPosition = function () {
              LocalizeTextField.prototype.correctPosition.call(this, 'center', 'center')
            };
            element.fitSize(true);
          }
        }
        const wildFieldCoef = this.children[0].getChildByName('paytable_wild_coef');
        wildFieldCoef.text = `×${EntryPoint.GameModel.paytableCurrentInfo['wildField']}`;
        wildFieldCoef.fitSize(true);
        wildFieldCoef.correctPosition = function () {
          LocalizeTextField.prototype.correctPosition.call(this, 'center', 'center')
        };
        const wildFieldPlusChiliMaxCoef = this.children[0].getChildByName('paytable_chili_coef', true);
        wildFieldPlusChiliMaxCoef.text = `×${EntryPoint.GameModel.paytableCurrentInfo['wildFieldPlusChili']}`;
        wildFieldPlusChiliMaxCoef.fitSize(true);
        wildFieldPlusChiliMaxCoef.correctPosition = function () {
          LocalizeTextField.prototype.correctPosition.call(this, 'center', 'center')
        }        ;
        break;
    }
  }

  setTextsStyle() {
    const text = this.children[0].getChildByName(`paytable_${this.currentFrame-1}_0`)
    if (text) {
      text.style = { ...text.style, ...startScreenFontStyle}
    }
  }

  changeFrame(event) {
    this.currentFrame = event.params || 1;
    this.goToFrame(this.currentFrame);
    this.setMultipliersStyle();
    this.setMultipliers()
    this.setTextsStyle()

    if (this.currentFrame === 1 && window.OPWrapperService.model.data.partnerConfig.certificationName === 'Malta') {
      this.children[0].getChildByName('paytable_coef').visible = false;
    }
  }

  destroy(){
    GlobalDispatcher.remove(eEventTypes.EET_PAYTABLE__CHANGE_PAGE, this.changeFrame, this);
    super.destroy();
  }
}
